/**
 * "How ideas are scored", opened from the "?" on the Business Opportunities
 * tab bar and on the Dashboard. One tab per topic. The dimensions, weights,
 * axes and threshold come from the catalogue (the database), so the guide
 * always matches what the totals and the matrix use.
 */

import type { Dimension } from '@/api/types';
import { GuideDialog } from '@/ui/GuideDialog';

import { IndustryPanel, MatrixPanel, ScoresPanel, VerdictPanel } from './scoringGuidePanels';

export function ScoringGuideDialog({
  dimensions,
  threshold,
  onClose,
}: {
  dimensions: Dimension[];
  threshold: number;
  onClose: () => void;
}) {
  return (
    <GuideDialog
      title="How ideas are scored"
      subtitle="Dimensions, the matrix, verdicts and industries"
      label="Scoring guide"
      onClose={onClose}
      tabs={[
        { key: 'scores', name: 'Scores', panel: <ScoresPanel dimensions={dimensions} /> },
        { key: 'matrix', name: 'Matrix', panel: <MatrixPanel dimensions={dimensions} threshold={threshold} /> },
        { key: 'verdict', name: 'Verdict', panel: <VerdictPanel /> },
        { key: 'industry', name: 'Industry', panel: <IndustryPanel /> },
      ]}
    />
  );
}
